<template>
    <div class="guest-invoices-pdfs-cell-renderer">
        <b-button ref="trigger" variant="outline-primary" data-action="toggle">
            <font-awesome-icon class="mr-1" :icon="['fas', 'download']"></font-awesome-icon>
            PDF Download
            <font-awesome-icon class="ml-1" :icon="['fas', 'caret-down']"></font-awesome-icon>
        </b-button>

        <div v-if="isOpen" ref="content" class="guest-invoices-pdfs-cell-renderer__menu-container">
            <a
                class="guest-invoices-pdfs-cell-renderer__menu-container__item"
                v-for="(rt, index) in reportTemplatesChoicesItems"
                :key="index"
                @click="togglePopup"
                :href="getReportTemplateDownloadURL(rt.id)"
            >
                {{ rt.report_name }}
            </a>
        </div>
    </div>
</template>

<script>
import tippy from 'tippy.js';
import { hideAll } from 'tippy.js';
import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';
import { RESERVATION_INVOICE_REPORT_TEMPLATE_DOWNLOAD_ENDPOINT } from '../../../endpoints';

export default {
    components: { ResponsiveButton },
    data() {
        return {
            isOpen: false,
            tippyInstance: null,
            reportTemplatesChoicesItems: [],
            reservationId: null,
        };
    },
    mounted() {
        this.reservationId = this.params.data.id;
        this.reportTemplatesChoicesItems = this.params.reportTemplatesChoicesItems;
        this.tippyInstance = tippy(this.$refs.trigger);
        this.tippyInstance.disable();
    },
    methods: {
        togglePopup() {
            this.isOpen = !this.isOpen;
            if (this.isOpen) {
                this.$nextTick(() => {
                    this.configureTippyInstance();
                    this.tippyInstance.setContent(this.$refs.content);
                });
            } else {
                this.tippyInstance.unmount();
            }
        },
        configureTippyInstance() {
            this.tippyInstance.enable();
            this.tippyInstance.show();
            this.tippyInstance.setProps({
                trigger: 'manual',
                placement: 'bottom-start',
                allowHTML: true,
                arrow: false,
                interactive: true,
                appendTo: document.body,
                hideOnClick: false,
                onShow: (instance) => {
                    hideAll({ exclude: instance });
                },
                onClickOutside: (instance, event) => {
                    this.isOpen = false;
                    instance.unmount();
                },
            });
        },
        getReportTemplateDownloadURL(id) {
            return RESERVATION_INVOICE_REPORT_TEMPLATE_DOWNLOAD_ENDPOINT(this.reservationId, id);
        },
    },
};
</script>

<style lang="scss" scoped>
.guest-invoices-pdfs-cell-renderer {
    &__menu-container {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans',
            'Helvetica Neue', sans-serif;
        position: absolute;
        z-index: 1000;
        min-width: 10rem;
        padding: 0.5rem 0;
        margin: 0;
        margin-left: -0.1rem;
        margin-top: -0.5rem;
        font-size: 1rem;
        text-align: left;
        list-style: none;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 0.25rem;

        &__item:hover {
            cursor: pointer;
            background: rgba(33, 150, 243, 0.1);
        }

        &__item.active {
            background-color: #dc3545;
            border-color: #dc3545;
            color: white;
        }
        &__item {
            display: block;
            padding: 0.5rem 1rem;
            clear: both;
            font-weight: 400;
            color: #212529;
            text-align: inherit;
            text-decoration: none;
            white-space: nowrap;
            border: 0;
        }
    }
}
</style>